<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="confirmDeliveryDate()" class="choose-flexibility-date-dialog">
  <app-product-delivery-moment
    (deliveryInformationChanged)="handleDeliveryInformationChange($event)"
    (deliveryInformationIsValid)="handleDeliveryInformationIsValidChange($event)"
    [deliveryInformation]="deliveryInformation"
    [allowedFlexibility]="allowedFlexibility"
    [cartId]="data.cartFlexibilityDate.id"
    [wizardMode]="ProductWizardMode.CART"
  >
  </app-product-delivery-moment>
</agr-dialog>
